import React from "react";

export interface ImageCardProps {
    imageUrl: string;
    imageTitle: string;
}

interface GallaboxCompareProps {
    mainTitle: string;
    imageCard: ImageCardProps[];
    description: string;
    keyPoints: string[];
}

const GallaboxSpotlightFeatures: React.FC<GallaboxCompareProps> = ({ mainTitle, imageCard, description, keyPoints }: GallaboxCompareProps) => {
    return (
        <div className="w-full lg:max-w-6xl mx-auto px-3 lg:px-0 md:mt-20 md:mb-20 mt-10 mb-10">
            <h2 className="mb-6 md:mb-10 text-center font-bold">{mainTitle}</h2>
            <div className="flex text-center justify-center gap-x-5 gap-y-10 flex-wrap md:flex-nowrap">
                {imageCard.map((imageCard) => (
                    <div key={imageCard.imageTitle}>
                        <img src={imageCard.imageUrl} alt={imageCard.imageTitle} width={278} height={319} />
                        <h3 className="text-2xl mt-3 font-medium" style={{ color: "#1A202C" }}>
                            {imageCard.imageTitle}
                        </h3>
                    </div>
                ))}
            </div>
            <p className="text-center md:text-left text-gray-600 mx-auto max-w-6xl text-lg mt-12 md:mb-10 mb-5">{description}</p>
            <div>
                <ul>
                    {keyPoints?.map((keyPoints) => {
                        return (
                            <li key={keyPoints} className="text-gray-600">
                                {keyPoints}
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default GallaboxSpotlightFeatures;
